import React from 'react';
import { RBAC_DISABLED_MESSAGE } from '../../../access-control/constants/strings';
import { RbacPermissions } from '../../../core/interfaces/user';
import { RbacService } from '../../../access-control/services/rbac.service';
import { HdButton, HdTooltip } from '../../../components';
import useService from '../../../injector/hooks/useService';

interface PlayButtonProps {
  dataId: string;
  paused: boolean;
  iconOnly: boolean;
  disabled?: boolean;
  pause: Function;
  resume: Function;
  rbacPermission: RbacPermissions;
  className?: string;
  pauseText?: string;
  resumeText?: string;
}

export function PlayButtonV1({
  paused,
  iconOnly,
  disabled,
  pause,
  resume,
  dataId,
  rbacPermission,
  className = '',
  pauseText = 'Pause',
  resumeText = 'Resume'
}: PlayButtonProps) {
  const _rbacService = useService(RbacService);
  const onClick = (event: any) => {
    event.disablePropagation = true;
    if (paused) {
      resume();
    } else {
      pause();
    }
  };
  const rbacTooltip = RBAC_DISABLED_MESSAGE;
  const blockedByRbac = !_rbacService.canTakeAction(rbacPermission);
  const isDisabled = blockedByRbac || disabled;
  const buttonText = paused ? resumeText : pauseText;

  return (
    <HdTooltip title={blockedByRbac ? rbacTooltip : buttonText}>
      <HdButton
        dataId={dataId}
        type='button'
        size='sm'
        iconOnly={iconOnly}
        disabled={isDisabled}
        iconClassName='icon-size-2'
        icon={paused ? 'play' : 'pause'}
        onKeyDown={(event: any) => {
          if (event.key === 'Enter') {
            onClick(event);
          }
        }}
        onClick={onClick}
        variation='outline'
        className={className}
      >
        {!iconOnly ? buttonText : ''}
      </HdButton>
    </HdTooltip>
  );
}
